<template>
  <react-button 
    v-bind:isReacted="comment.meta.isLiked" 
    v-bind:numReactions="comment.meta.numLikes" 
    v-bind:name="'Like'" 
    v-bind:icon="'fa-check-circle'"
    @toggleOn="likeComment()" 
    @toggleOff="unlikeComment()"
  />
</template>

<script>
  import CommentLikeButton from "./CommentLikeButton.ts";

  export default CommentLikeButton;
</script>
